export default __webpack_public_path__ + "static/media/download_button.187dd7c6.svg";